import GlobalStore from 'src/stores/GlobalStore/GlobalStore';
import NotificationStore from 'src/stores/NotificationStore/NotificationStore';
import { Interceptor } from '../FetchService';

function createErrorInterceptor(
    globalStore: GlobalStore,
    notificationStore: NotificationStore
): Interceptor {
    return (next) => async (request: Request) => {
        const response: Response = await next(request);
        if (!response.ok) {
            const data = await response.text();
            if (response.status === 401 && data === '') {
                globalStore.clearUserAndRouteToLogin();
                notificationStore.sendNotification('401', 'Session has ended. Please login.', {
                    persist: false,
                    variant: 'error',
                });
            } else if (data === '') {
                notificationStore.sendNotification(
                    response.url,
                    'An error has occurred: ' + response.statusText,
                    { variant: 'error' }
                );
            } else {
                notificationStore.sendNotification(response.url, data, {
                    variant: 'error',
                });
            }
            return Promise.reject(response);
        }
        return response;
    };
}

export default createErrorInterceptor;



// WEBPACK FOOTER //
// ./src/core/ErrorInterceptor/ErrorInterceptor.ts